//resources/js/Components/LanguageSwitcher.jsx
import React from 'react';  
    
import { usePage } from '@inertiajs/react';
import { Inertia } from '@inertiajs/inertia'; // Usamos Inertia para hacer el request

export default function LanguageSwitcher() {
    // Obtenemos el locale actual de las Shared Props
    //const { locale } = usePage().props;
    const { lang } = usePage().props; 
    const currentLocale = lang.locale;    

    const languages = [
        { code: 'es', name: 'Español' },
        { code: 'en', name: 'English' },
        { code: 'it', name: 'Italiano' },
        { code: 'pt', name: 'Português' },
        { code: 'de', name: 'Deutsch' },
        { code: 'fr', name: 'Français' },
        { code: 'ru', name: 'Русский' },
        { code: 'ja', name: '日本語' },
        // Aquí se agregarían otros idiomas (de, pt, fr, etc.)
    ];

    const handleLanguageChange = (e) => {
        const selectedLocale = e.target.value;
        // Hacemos una solicitud GET con el nuevo locale.
        // El Middleware de Laravel debe interceptar esto para cambiar el idioma
        Inertia.get(route('language.switch', selectedLocale), {}, {
            preserveScroll: true,
            preserveState: false, // Forzamos un refresh completo para que se recarguen todas las props
        });
    };

    return (
        <select 
            onChange={handleLanguageChange} 
            defaultValue={currentLocale}
            
            className="border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 rounded-md shadow-sm text-sm"
        >
            {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                    {lang.name}
                </option>
            ))}
        </select>
    );
}    
